import { styled, Typography } from "@mui/material";

export const StyledFormicError = styled(Typography)`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 0.75rem;
`;
